export default {
    title: {
        email: '电邮',
        password: '密码'
    },
    view: {
        login: {
            title: '登陆 Guardian System v0.0.1',
            button: {
                login: '登陆',
                signup: '注册'
            },
            error: {
                invalid: "电邮或密码无效。请再次尝试 "
            }
        }
    }
}